import i18n from 'i18next';
import type { Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

async function buildResources(): Promise<Resource> {
  const resources: Resource = {};

  if (__LOCALE_EN__) resources.en = (await import('./en')).default;
  if (__LOCALE_RU__) resources.ru = (await import('./ru')).default;
  if (__LOCALE_PTBR__) resources['pt-BR'] = (await import('./pt')).default;
  if (__LOCALE_ESES__) resources.es = (await import('./es')).default;

  return resources;
}

const isWhitelabel = import.meta.env.MODE === 'whitelabel';

if (!isWhitelabel) {
  i18n.use(LanguageDetector);
}

export const i18nReady = buildResources().then(async (resources) => i18n
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'htmlTag', 'navigator'],
      convertDetectedLanguage: (language) => {
        if (language === 'ptBr') return 'pt-BR';
        if (language === 'esEs') return 'es';
        return language;
      },
    },
    resources,
    ns: ['common', 'handlers', 'списки'],
    defaultNS: 'common',
    fallbackNS: ['common'],
    debug: false,
    nsSeparator: ':',
    ...(isWhitelabel ? { lng: 'en' } : {}),
  }));

export default i18n;
